import { render, staticRenderFns } from "./sidemenu_instagram.vue?vue&type=template&id=39232f2e&scoped=true&"
import script from "./sidemenu_instagram.vue?vue&type=script&lang=js&"
export * from "./sidemenu_instagram.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu_instagram.vue?vue&type=style&index=0&id=39232f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39232f2e",
  null
  
)

export default component.exports